namespace RedBullMOBILE360.Texts {

    export declare namespace Db {

        namespace Administration {

            namespace DbLinkMap {
                export const Id: string;
                export const LinkAlias: string;
                export const ReplaceBy: string;
            }

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const DisplayName: string;
                export const Email: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LastDirectoryUpdate: string;
                export const LastLogin: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const Password: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Roles: string;
                export const Source: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace AutomaticReports {

            namespace MonitorAlert {
                export const AlertChannel: string;
                export const AlertMsg: string;
                export const Audience: string;
                export const Enabled: string;
                export const Id: string;
                export const QueryString: string;
                export const Schedule: string;
            }

            namespace Report {
                export const Id: string;
                export const IsEnabled: string;
                export const Recipients: string;
                export const ReportChannel: string;
                export const Schedule: string;
                export const Subject: string;
                export const Template: string;
            }

            namespace ReportLog {
                export const Id: string;
                export const Recipients: string;
                export const ReportId: string;
                export const SendingDate: string;
                export const Status: string;
            }

            namespace ReportPart {
                export const Id: string;
                export const IsAttachment: string;
                export const PartName: string;
                export const PartQuery: string;
                export const PartTitle: string;
                export const PartType: string;
                export const ReportId: string;
                export const ReportIsEnabled: string;
                export const ReportRecipients: string;
                export const ReportReportChannel: string;
                export const ReportSchedule: string;
                export const ReportSubject: string;
                export const ReportTemplate: string;
            }
        }

        namespace BulkSMS {

            namespace BulkSMS {
                export const Id: string;
                export const SmsContent: string;
                export const SmsDate: string;
                export const SmsStatus: string;
                export const SmsType: string;
            }
        }

        namespace CVM {

            namespace CriteriaCondition {
                export const Condition: string;
                export const Id: string;
                export const Name: string;
            }

            namespace CvmCampaign {
                export const Duration: string;
                export const Id: string;
                export const Name: string;
                export const NextRun: string;
            }

            namespace CvmSegment {
                export const ActionType: string;
                export const CampaignId: string;
                export const Criteria: string;
                export const Id: string;
                export const IsEnabled: string;
                export const OfferId: string;
                export const Title: string;
            }

            namespace OfferRedemption {
                export const Id: string;
                export const Msisdn: string;
                export const RedemptionDate: string;
                export const SegmentId: string;
                export const SegmentOfferId: string;
                export const SegmentTitle: string;
            }

            namespace SegmentCriteria {
                export const Condition: string;
                export const ConditionId: string;
                export const ConditionName: string;
                export const Id: string;
                export const SegmentId: string;
                export const SegmentOfferId: string;
                export const SegmentTitle: string;
            }
        }

        namespace CustomerCare {

            namespace BlockedSMSCustomers {
                export const CreationDate: string;
                export const Id: string;
                export const Msisdn: string;
            }

            namespace LineTerminationReport {
                export const AgentId: string;
                export const AgentUserName: string;
                export const BssRequest: string;
                export const BssResponse: string;
                export const Id: string;
                export const IdNumber: string;
                export const Msisdn: string;
                export const OrderLat: string;
                export const OrderLng: string;
                export const Otp: string;
                export const SellerId: string;
                export const Status: string;
                export const TransDate: string;
            }

            namespace ManualResumeFraudCases {
                export const IdNumber: string;
                export const Msisdn: string;
            }

            namespace ThreeThreeZeroNotification {
                export const ActionDate: string;
                export const ActionType: string;
                export const ActivationDate: string;
                export const ExtraActionPeriodDays: string;
                export const FirstActionDate: string;
                export const Id: string;
                export const NotificationCounter: string;
                export const NotificationSource: string;
                export const OperatorTcn: string;
                export const PersonId: string;
                export const PrimaryOffer: string;
                export const ReportDate: string;
                export const ReportedIdentity: string;
                export const ReporterList: string;
                export const SecondActionDate: string;
                export const SimType: string;
                export const Status: string;
                export const Tcn: string;
                export const TypeOfComplaint: string;
                export const UserCurrentStatus: string;
                export const UserPrimaryOfferId: string;
            }

            namespace UnBlockedSMSCustomers {
                export const CreationDate: string;
                export const Id: string;
                export const Msisdn: string;
            }
        }

        namespace ESim {

            namespace EsimActivationCode {
                export const ActivationCode: string;
                export const CreationDate: string;
                export const Iccid: string;
                export const Id: string;
                export const Pin: string;
                export const Puk: string;
            }
        }

        namespace LoanWhitelist {

            namespace LoanWhitelist {
                export const Id: string;
                export const Msisdn: string;
            }
        }

        namespace PushNotifications {

            namespace PushNotifications {
                export const ExcelFileName: string;
                export const Id: string;
                export const IsExcelUploaded: string;
                export const NotificationDate: string;
                export const Sender: string;
                export const Status: string;
            }

            namespace PushNotificationsPG {
                export const Excelfilename: string;
                export const Id: string;
                export const Isexceluploaded: string;
                export const Notificationdate: string;
                export const Sender: string;
                export const Status: string;
            }
        }

        namespace SMPPAccount {

            namespace SMPPAccount {
                export const AccountId: string;
                export const SystemId: string;
            }
        }

        namespace SMSCodes {

            namespace InformativeSms {
                export const Code: string;
                export const Id: string;
                export const MessageAr: string;
                export const MessageEn: string;
            }

            namespace ServiceSms {
                export const Code: string;
                export const Endpoint: string;
                export const Id: string;
                export const ReturnField: string;
                export const ReturnMsgField: string;
                export const ReturnNamespace: string;
                export const ServiceName: string;
                export const SoapAction: string;
                export const XmlRequest: string;
            }

            namespace SubscriptionCodes {
                export const IsActive: string;
                export const IsPrimary: string;
                export const OfferId: string;
                export const OfferName: string;
                export const StopAtrnwCode: string;
                export const SubscriptionCode: string;
                export const UnsubscriptionCode: string;
            }
        }

        namespace SalesApp {

            namespace Addon {
                export const AllowedChannles: string;
                export const AllowedIdTypes: string;
                export const Benefits: string;
                export const BenefitsAr: string;
                export const Category: string;
                export const Commission: string;
                export const Id: string;
                export const IsActive: string;
                export const NameAr: string;
                export const NameEn: string;
                export const Price: string;
                export const Validity: string;
            }

            namespace WalletTransfer {
                export const Amount: string;
                export const FromPartner: string;
                export const Id: string;
                export const PartnerBalanceAfter: string;
                export const PartnerBalanceBefore: string;
                export const ReferenceNo: string;
                export const SellerBalanceAfter: string;
                export const SellerBalanceBefore: string;
                export const ToAgent: string;
                export const TransDate: string;
                export const TransferBy: string;
                export const TransferType: string;
            }
        }

        namespace SenderName {

            namespace SenderName {
                export const Name: string;
                export const SenderId: string;
            }
        }

        namespace Settings {

            namespace ServiceParameters {
                export const AuthToken: string;
                export const Id: string;
                export const Name: string;
                export const OfferId: string;
            }
        }

        namespace Sms {

            namespace Addon {
                export const AllowedChannles: string;
                export const AllowedIdTypes: string;
                export const Benefits: string;
                export const BenefitsAr: string;
                export const Category: string;
                export const Commission: string;
                export const EsimOfferId: string;
                export const Id: string;
                export const IsActive: string;
                export const NameAr: string;
                export const NameEn: string;
                export const Price: string;
                export const Validity: string;
            }

            namespace CampaignEligibility {
                export const Id: string;
                export const OfferId: string;
                export const OfferIsActive: string;
                export const OfferIsPrimary: string;
                export const OfferOfferName: string;
                export const OfferStopAtrnwCode: string;
                export const OfferSubscriptionCode: string;
                export const OfferUnsubscriptionCode: string;
                export const WhitelistCreatedBy: string;
                export const WhitelistCreationDate: string;
                export const WhitelistId: string;
                export const WhitelistLastUpdateDate: string;
                export const WhitelistWhitelistName: string;
            }

            namespace ExclusiveOffers {
                export const ExclusiveOfferId: string;
                export const Id: string;
                export const IsEnabled: string;
                export const OfferId: string;
            }

            namespace SubscriptionCodes {
                export const Eligibility: string;
                export const IsActive: string;
                export const IsPrimary: string;
                export const OfferId: string;
                export const OfferName: string;
                export const StopAtrnwCode: string;
                export const SubscriptionCode: string;
                export const UnsubscriptionCode: string;
            }

            namespace WhiteList {
                export const CreatedBy: string;
                export const CreationDate: string;
                export const Id: string;
                export const LastUpdateDate: string;
                export const WhitelistName: string;
            }

            namespace WhitelistMember {
                export const AddBy: string;
                export const AddDate: string;
                export const Id: string;
                export const Msisdn: string;
                export const WhitelistCreatedBy: string;
                export const WhitelistCreationDate: string;
                export const WhitelistId: string;
                export const WhitelistLastUpdateDate: string;
                export const WhitelistWhitelistName: string;
            }
        }

        namespace SpecialEvent {

            namespace SpecialEvent {
                export const EventName: string;
                export const Id: string;
                export const ImageUrl: string;
                export const UploadDate: string;
            }
        }

        namespace Utilities {

            namespace ReAuthenticateMsisdn {
                export const BssRequest: string;
                export const BssResponse: string;
                export const CreationDate: string;
                export const FirstName: string;
                export const IamOtp: string;
                export const Iccid: string;
                export const Id: string;
                export const IdNumber: string;
                export const IdType: string;
                export const IsEsim: string;
                export const IsMnp: string;
                export const LastName: string;
                export const Msisdn: string;
                export const Nationality: string;
                export const OperationType: string;
                export const PrepostPaid: string;
                export const Status: string;
                export const TccIdNumber: string;
                export const TccRequest: string;
                export const TccResponse: string;
            }

            namespace ReAuthenticateNumbers {
                export const BssRequest: string;
                export const BssResponse: string;
                export const CreationDate: string;
                export const FirstName: string;
                export const IamOtp: string;
                export const Iccid: string;
                export const Id: string;
                export const IdNumber: string;
                export const IdType: string;
                export const IsEsim: string;
                export const IsMnp: string;
                export const LastName: string;
                export const Msisdn: string;
                export const Nationality: string;
                export const OperationType: string;
                export const PrepostPaid: string;
                export const Status: string;
                export const TccIdNumber: string;
                export const TccRequest: string;
                export const TccResponse: string;
            }
        }
    }

    export declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    export declare namespace Navigation {
        export const LogoutLink: string;
        export const SiteTitle: string;
    }

    export declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    export declare namespace Validation {
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const PasswordMustHaveDigit: string;
        export const PasswordMustHaveLowerLetter: string;
        export const PasswordMustHaveUpperLetter: string;
        export const PasswordMustHavespecialCharacter: string;
        export const SavePrimaryKeyError: string;
    }

    RedBullMOBILE360['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{DbLinkMap:{Id:1,LinkAlias:1,ReplaceBy:1},Language:{Id:1,LanguageId:1,LanguageName:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{DisplayName:1,Email:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,IsActive:1,LastDirectoryUpdate:1,LastLogin:1,MobilePhoneNumber:1,MobilePhoneVerified:1,Password:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,Roles:1,Source:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserId:1,UserImage:1,Username:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},AutomaticReports:{MonitorAlert:{AlertChannel:1,AlertMsg:1,Audience:1,Enabled:1,Id:1,QueryString:1,Schedule:1},Report:{Id:1,IsEnabled:1,Recipients:1,ReportChannel:1,Schedule:1,Subject:1,Template:1},ReportLog:{Id:1,Recipients:1,ReportId:1,SendingDate:1,Status:1},ReportPart:{Id:1,IsAttachment:1,PartName:1,PartQuery:1,PartTitle:1,PartType:1,ReportId:1,ReportIsEnabled:1,ReportRecipients:1,ReportReportChannel:1,ReportSchedule:1,ReportSubject:1,ReportTemplate:1}},BulkSMS:{BulkSMS:{Id:1,SmsContent:1,SmsDate:1,SmsStatus:1,SmsType:1}},CVM:{CriteriaCondition:{Condition:1,Id:1,Name:1},CvmCampaign:{Duration:1,Id:1,Name:1,NextRun:1},CvmSegment:{ActionType:1,CampaignId:1,Criteria:1,Id:1,IsEnabled:1,OfferId:1,Title:1},OfferRedemption:{Id:1,Msisdn:1,RedemptionDate:1,SegmentId:1,SegmentOfferId:1,SegmentTitle:1},SegmentCriteria:{Condition:1,ConditionId:1,ConditionName:1,Id:1,SegmentId:1,SegmentOfferId:1,SegmentTitle:1}},CustomerCare:{BlockedSMSCustomers:{CreationDate:1,Id:1,Msisdn:1},LineTerminationReport:{AgentId:1,AgentUserName:1,BssRequest:1,BssResponse:1,Id:1,IdNumber:1,Msisdn:1,OrderLat:1,OrderLng:1,Otp:1,SellerId:1,Status:1,TransDate:1},ManualResumeFraudCases:{IdNumber:1,Msisdn:1},ThreeThreeZeroNotification:{ActionDate:1,ActionType:1,ActivationDate:1,ExtraActionPeriodDays:1,FirstActionDate:1,Id:1,NotificationCounter:1,NotificationSource:1,OperatorTcn:1,PersonId:1,PrimaryOffer:1,ReportDate:1,ReportedIdentity:1,ReporterList:1,SecondActionDate:1,SimType:1,Status:1,Tcn:1,TypeOfComplaint:1,UserCurrentStatus:1,UserPrimaryOfferId:1},UnBlockedSMSCustomers:{CreationDate:1,Id:1,Msisdn:1}},ESim:{EsimActivationCode:{ActivationCode:1,CreationDate:1,Iccid:1,Id:1,Pin:1,Puk:1}},LoanWhitelist:{LoanWhitelist:{Id:1,Msisdn:1}},PushNotifications:{PushNotifications:{ExcelFileName:1,Id:1,IsExcelUploaded:1,NotificationDate:1,Sender:1,Status:1},PushNotificationsPG:{Excelfilename:1,Id:1,Isexceluploaded:1,Notificationdate:1,Sender:1,Status:1}},SMPPAccount:{SMPPAccount:{AccountId:1,SystemId:1}},SMSCodes:{InformativeSms:{Code:1,Id:1,MessageAr:1,MessageEn:1},ServiceSms:{Code:1,Endpoint:1,Id:1,ReturnField:1,ReturnMsgField:1,ReturnNamespace:1,ServiceName:1,SoapAction:1,XmlRequest:1},SubscriptionCodes:{IsActive:1,IsPrimary:1,OfferId:1,OfferName:1,StopAtrnwCode:1,SubscriptionCode:1,UnsubscriptionCode:1}},SalesApp:{Addon:{AllowedChannles:1,AllowedIdTypes:1,Benefits:1,BenefitsAr:1,Category:1,Commission:1,Id:1,IsActive:1,NameAr:1,NameEn:1,Price:1,Validity:1},WalletTransfer:{Amount:1,FromPartner:1,Id:1,PartnerBalanceAfter:1,PartnerBalanceBefore:1,ReferenceNo:1,SellerBalanceAfter:1,SellerBalanceBefore:1,ToAgent:1,TransDate:1,TransferBy:1,TransferType:1}},SenderName:{SenderName:{Name:1,SenderId:1}},Settings:{ServiceParameters:{AuthToken:1,Id:1,Name:1,OfferId:1}},Sms:{Addon:{AllowedChannles:1,AllowedIdTypes:1,Benefits:1,BenefitsAr:1,Category:1,Commission:1,EsimOfferId:1,Id:1,IsActive:1,NameAr:1,NameEn:1,Price:1,Validity:1},CampaignEligibility:{Id:1,OfferId:1,OfferIsActive:1,OfferIsPrimary:1,OfferOfferName:1,OfferStopAtrnwCode:1,OfferSubscriptionCode:1,OfferUnsubscriptionCode:1,WhitelistCreatedBy:1,WhitelistCreationDate:1,WhitelistId:1,WhitelistLastUpdateDate:1,WhitelistWhitelistName:1},ExclusiveOffers:{ExclusiveOfferId:1,Id:1,IsEnabled:1,OfferId:1},SubscriptionCodes:{Eligibility:1,IsActive:1,IsPrimary:1,OfferId:1,OfferName:1,StopAtrnwCode:1,SubscriptionCode:1,UnsubscriptionCode:1},WhiteList:{CreatedBy:1,CreationDate:1,Id:1,LastUpdateDate:1,WhitelistName:1},WhitelistMember:{AddBy:1,AddDate:1,Id:1,Msisdn:1,WhitelistCreatedBy:1,WhitelistCreationDate:1,WhitelistId:1,WhitelistLastUpdateDate:1,WhitelistWhitelistName:1}},SpecialEvent:{SpecialEvent:{EventName:1,Id:1,ImageUrl:1,UploadDate:1}},Utilities:{ReAuthenticateMsisdn:{BssRequest:1,BssResponse:1,CreationDate:1,FirstName:1,IamOtp:1,Iccid:1,Id:1,IdNumber:1,IdType:1,IsEsim:1,IsMnp:1,LastName:1,Msisdn:1,Nationality:1,OperationType:1,PrepostPaid:1,Status:1,TccIdNumber:1,TccRequest:1,TccResponse:1},ReAuthenticateNumbers:{BssRequest:1,BssResponse:1,CreationDate:1,FirstName:1,IamOtp:1,Iccid:1,Id:1,IdNumber:1,IdType:1,IsEsim:1,IsMnp:1,LastName:1,Msisdn:1,Nationality:1,OperationType:1,PrepostPaid:1,Status:1,TccIdNumber:1,TccRequest:1,TccResponse:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Navigation:{LogoutLink:1,SiteTitle:1},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AuthenticationError:1,CantFindUserWithEmail:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,PasswordMustHaveDigit:1,PasswordMustHaveLowerLetter:1,PasswordMustHaveUpperLetter:1,PasswordMustHavespecialCharacter:1,SavePrimaryKeyError:1}}) as any;
}
